/**
 * The nearest ancestor that really scrolls vertically. Its style alone doesn't say it: `overflow-x: auto`
 * turns a visible `overflow-y` into `auto` too, on a wrapper that just grows with its content.
 * None (everything fits): null, which callers read as the viewport.
 */
export const scrollParent = (element: HTMLElement | null): HTMLElement | null => {
  for (let node = element?.parentElement; node; node = node.parentElement) {
    const { overflowY } = getComputedStyle(node);
    if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
  }
  return null;
};

export default scrollParent;
